/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { usePolicy } from '../hooks/usePolicy';
import { useLists } from '../hooks/useLists';
import ContentLoader from '../components/ContentLoader';
import { useActiveUser } from '../hooks/useUser';
import { useUIState } from '../hooks/useUIState';

const LoadRequiredData = (props) => {
  const [policyData] = usePolicy(true);
  const [listData, listActions] = useLists();
  const isLoaded = policyData.isLoaded && listData.isLoaded;
  const [{ user }, userActions] = useActiveUser();
  const [, uiActions] = useUIState();

  React.useEffect(() => {
    document.body.classList.add('bkgd-color-appGutterBackground');
  }, []);

  React.useEffect(() => {
    if (!isLoaded) { return; }
    if (!user.locale_id) {
      const locale = listActions.getClosestMatchingLocale();
      userActions.setClientLocale(locale);
      uiActions.setLocale(locale);
    }
  }, [isLoaded]);

  return isLoaded ? props.children : <ContentLoader isContentLoaded={false} isFixed />;
};

export default LoadRequiredData;
